export default "__VITE_ASSET__84a70c59__"